<template>
	<div style="height:375px;">
		<h4 class="inner_h5">
			Class List
			<span class="int_type2 mgl_15">
				<input type="text" v-model="searchName" class="int_type" v-on:keyup.enter="selectList" autocomplete="off" />
			</span>
			<span>
				<a href="javascript:void(0);" class="gray_bt" @click="selectList()">Search</a>
			</span>
		</h4>
		<div class="fixed-table-container340" ref="div_wrapper_parent">
			<div class="table-wrapper" ref="div_wrapper_box">
				<table class="list_tbl tbl_pointer" border="0">
					<colgroup>
						<col style="width:5%;" />
						<col style="width:10%;" />
						<col style="width:20%;" />
						<col style="" />
						<col style="width:20%;" />
						<col style="width:5%;" />
					</colgroup>
					<thead>
						<tr>
							<th class="al_center"><div class="th-text">No</div></th>
							<th class="al_center">
								<div class="th-text">{{ headers.class }} Code</div>
							</th>
							<th class="al_center"><div class="th-text">WH Code</div></th>
							<th class="al_center">
								<div class="th-text">{{ headers.class }} Name</div>
							</th>
							<th class="al_center"><div class="th-text">Group</div></th>
							<th class="al_center"><div class="th-text">Items</div></th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(cls, index) of list" v-bind:key="index" @dblclick="selectClass(cls.code)">
							<td>{{ index + 1 }}</td>
							<td>{{ cls.code }}</td>
							<td>{{ cls.wh_code }}</td>
							<td>{{ cls.name }}</td>
							<td>{{ cls.class_group_name }}</td>
							<td class="al_right">{{ cls.item_count | commaSeparated }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>
<script>
import { apiSelectItemClassList } from '@/api/item/class';

export default {
	name: 'UserDefinedGroupItemClassList',
	data: function() {
		return { list: [], searchName: '' };
	},
	methods: {
		async selectList() {
			const param = {
				keyword: this.searchName,
				paging_yn: 'N',
				active_yn: 'Y',
				closed_yn: 'N',
			};
			const { data } = await apiSelectItemClassList(param);
			this.list = data.itemClassList;
		},
		selectClass(code) {
			this.$emit('input', code);
		},
	},
	computed: {
		headers: function() {
			return { class: this.$session.get('headerClass') };
		},
	},
	mounted() {
		this.selectList();
	},
};
</script>
